import React from 'react';
import Skeleton from 'components/LoadingSkeleton';

const CoachDashboardHeaderSkeleton = () => {
  return (
    <div className="border-b border-color-border-input-lightmode py-ds-3xl dark:border-color-border-input-darkmode max-sm:py-5">
      <div className="container mx-auto flex flex-wrap gap-ds-xl  max-sm:px-4">
        <h3 className="typography-product-heading-desktop max-md:typography-product-heading-mobile">
          Welcome, Coach <Skeleton width={100} height={20} />
        </h3>

        <div className="flex flex-1 justify-between gap-ds-md">
          <div className="flex">
            <div className="flex items-center gap-1.5 border-l border-color-border-input-lightmode  px-ds-lg py-1.5 dark:border-color-border-input-darkmode max-sm:flex-col max-sm:justify-between sm:py-2">
              <div className="mb-0.5 h-4 w-4" />
              <span className="typography-product-subheading max-sm:typography-product-card-title-mobile text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                <Skeleton width={30} height={16} />
              </span>
            </div>
            <div className="flex items-center gap-1.5 border-l border-r border-color-border-input-lightmode px-ds-lg py-1.5 dark:border-color-border-input-darkmode max-sm:flex-col max-sm:justify-between sm:py-2">
              <div className="h-4 w-5" />
              <span className="typography-product-subheading max-sm:typography-product-card-title-mobile text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                <Skeleton width={30} height={16} />
              </span>
            </div>
          </div>
          <div className="flex gap-ds-md max-md:items-center">
            <div className="h-10 w-32 rounded-lg bg-gray-200 dark:bg-gray-700" />
            <div className="h-10 w-32 rounded-lg bg-gray-200 dark:bg-gray-700 max-md:hidden" />
            <div className="h-8 w-8 rounded-lg bg-gray-200 dark:bg-gray-700 md:hidden" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachDashboardHeaderSkeleton;
